module.exports = __webpack_public_path__ + "static/img/audio-bg.40add5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/audio-bg.png
// module id = C15C
// module chunks = 96